import { render, staticRenderFns } from "./BookingPopoutSetup.vue?vue&type=template&id=1941cde8&scoped=true&"
import script from "./BookingPopoutSetup.vue?vue&type=script&lang=js&"
export * from "./BookingPopoutSetup.vue?vue&type=script&lang=js&"
import style0 from "./BookingPopoutSetup.vue?vue&type=style&index=0&id=1941cde8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1941cde8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VTextField,VTooltip})
